(function () {
  function bumpCartBubble() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('is-updated');
    window.requestAnimationFrame(function () {
      bubble.classList.add('is-updated');
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, bumpCartBubble);
  }
})();
